import { FC, useCallback, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

import { usePagination } from '@/Components/Hooks';
import { Pagination } from '@/Components/UI';
import { NotificationResource } from '@/Services/api/methods/v2/Notifications/response';
import { notificationsStoreSelectors } from '@/Store/notifications/notificationsState';

import { NotificationCard } from '../NotificationCard';
import { NotificationsListProps } from './NotificationsList.types';
import S from './styles.module.scss';

export const NotificationsList: FC<NotificationsListProps> = ({ id, type }) => {
    const [query] = useSearchParams();

    const { changePage, currentPage, lastPage, nextPage, perPage, prevPage, process } = usePagination(10);

    const loadNotifications = notificationsStoreSelectors.use.loadNotifications();
    const readNotifications = notificationsStoreSelectors.use.readNotifications();

    const notifications = notificationsStoreSelectors.use.notifications();

    const handleNotificationClick = useCallback(
        (notification: NotificationResource) => {
            readNotifications({
                notifiable: {
                    type: type,
                    id: id,
                },
                notifications_ids: [notification.id],
            });
        },
        [id, type, readNotifications]
    );

    useEffect(() => {
        loadNotifications(
            {
                'notifiable[id]': id,
                'notifiable[type]': type,
                order_by: 'newest',
                is_read: query.get('is_read') ?? undefined,
                page: currentPage,
                per_page: perPage,
            },
            process
        );
    }, [id, type, query, currentPage, perPage, loadNotifications, process]);

    return (
        <div className={S.notifications}>
            {notifications.map((notification) => (
                <NotificationCard notification={notification} onClick={() => handleNotificationClick(notification)} key={`notification-${notification.id}`} />
            ))}
            {lastPage && lastPage > 1 && (
                <Pagination current={currentPage} last={lastPage ?? 1} prevPage={prevPage} nextPage={nextPage} changePage={changePage} />
            )}
        </div>
    );
};
